import { HeroSection } from "../components/HeroSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { WhatYouSkipSection } from "../components/WhatYouSkipSection";
import { WalletSection } from "../components/WalletSection";
import { DashboardSection } from "../components/DashboardSection";
import { PricingSection } from "../components/PricingSection";
import { CtaSection } from "../components/CtaSection";
import { Footer } from "../components/Footer";

export function HomePage() {
  return (
    <main>
      <HeroSection />
      <HowItWorksSection />
      <WhatYouSkipSection />
      <WalletSection />
      <DashboardSection />
      <PricingSection />
      <CtaSection />
      <Footer />
    </main>
  );
}
